"use strict";

var _objectWithoutProperties = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/objectWithoutProperties");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepperComponent = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _utils = require("@creditas/utils");

var _XCircle = _interopRequireDefault(require("@creditas/icons/dist/action/XCircle"));

var _PlusCircle = _interopRequireDefault(require("@creditas/icons/dist/action/PlusCircle"));

var _MinusCircle = _interopRequireDefault(require("@creditas/icons/dist/content/MinusCircle"));

var _CheckCircle = _interopRequireDefault(require("@creditas/icons/dist/notification/CheckCircle"));

var _AlertTriangle = _interopRequireDefault(require("@creditas/icons/dist/alert/AlertTriangle"));

var _utils2 = require("./utils");

var _Stepper = require("./components/Stepper");

var _core = require("@emotion/core");

var propTypes = {
  label: _propTypes.string,
  value: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
  placeholder: _propTypes.string,
  prefix: _propTypes.string,
  suffix: _propTypes.string,
  color: _propTypes.string,
  variant: _propTypes.string,
  required: _propTypes.bool,
  disabled: _propTypes.bool,
  onInput: _propTypes.func,
  onChange: _propTypes.func,
  onFocus: _propTypes.func,
  onDecrement: _propTypes.func,
  onIncrement: _propTypes.func,
  onBlur: _propTypes.func
};

var IconSuccess = function IconSuccess() {
  return (0, _core.jsx)(_CheckCircle["default"], {
    color: "success"
  });
};

var IconWarning = function IconWarning() {
  return (0, _core.jsx)(_XCircle["default"], {
    color: "warning"
  });
};

var IconError = function IconError() {
  return (0, _core.jsx)(_AlertTriangle["default"], {
    color: "danger",
    fontSize: "default"
  });
};

var Icons = {
  success: IconSuccess,
  danger: IconError,
  warning: IconWarning
};

var Icon = function Icon(_ref) {
  var variant = _ref.variant;
  var Variant = Icons[variant];
  return Variant ? (0, _core.jsx)(Variant, null) : '';
};

process.env.NODE_ENV !== "production" ? Icon.propTypes = {
  variant: _propTypes.string
} : void 0;
var enhancer = (0, _utils.compose)(_utils.withForwardRef, (0, _utils.withDefaultProps)(propTypes));
var element = enhancer(function (_ref2) {
  var component = _ref2.component,
      className = _ref2.className,
      dataTestId = _ref2['data-testid'],
      withRef = _ref2.withRef,
      label = _ref2.label,
      value = _ref2.value,
      suffix = _ref2.suffix,
      prefix = _ref2.prefix,
      variant = _ref2.variant,
      color = _ref2.color,
      required = _ref2.required,
      disabled = _ref2.disabled,
      placeholder = _ref2.placeholder,
      onInput = _ref2.onInput,
      onChange = _ref2.onChange,
      onFocus = _ref2.onFocus,
      onBlur = _ref2.onBlur,
      onIncrement = _ref2.onIncrement,
      onDecrement = _ref2.onDecrement,
      other = _objectWithoutProperties(_ref2, ["component", "className", "data-testid", "withRef", "label", "value", "suffix", "prefix", "variant", "color", "required", "disabled", "placeholder", "onInput", "onChange", "onFocus", "onBlur", "onIncrement", "onDecrement"]);

  var handleCaret = function handleCaret(e) {
    e.stopPropagation();
    (0, _utils2.setCaretPosition)(withRef.current, prefix, suffix);
  };

  return (0, _core.jsx)(_react["default"].Fragment, null, label && (0, _core.jsx)(_Stepper.StepperLabel, null, label), color !== 'default' && !disabled && (0, _core.jsx)(Icon, {
    variant: variant
  }), (0, _core.jsx)(_Stepper.StepperButton, {
    type: "button",
    "data-testid": "stepper-decrement",
    onClick: onDecrement
  }, (0, _core.jsx)(_MinusCircle["default"], {
    color: color,
    fontSize: "large"
  })), (0, _core.jsx)(_Stepper.StepperInput, (0, _extends2["default"])({
    type: "text",
    as: component,
    ref: withRef,
    className: className,
    "data-testid": dataTestId,
    color: color,
    placeholder: placeholder,
    value: value,
    required: required,
    disabled: disabled,
    onInput: onInput,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    onPointerUp: handleCaret,
    onPointerDown: handleCaret,
    onKeyDown: handleCaret,
    onKeyUp: handleCaret
  }, other)), (0, _core.jsx)(_Stepper.StepperButton, {
    type: "button",
    "data-testid": "stepper-increment",
    onClick: onIncrement
  }, (0, _core.jsx)(_PlusCircle["default"], {
    color: color,
    fontSize: "large"
  })));
});
exports.StepperComponent = element;